import { render, staticRenderFns } from "./Acerto.vue?vue&type=template&id=35334110&scoped=true"
import script from "./Acerto.vue?vue&type=script&lang=js"
export * from "./Acerto.vue?vue&type=script&lang=js"
import style0 from "./Acerto.vue?vue&type=style&index=0&id=35334110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35334110",
  null
  
)

export default component.exports